<template>
  <PropertyDetailsCard>
    <template #title>Property details</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyGeneralDetailsInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added property details yet"
      subtitle="Add detailed information to showcase what makes your rental special"
      button-text="Add property details"
      @button-clicked="showModal"
    />
    <SpecificationsModal ref="specificationsModal" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyGeneralDetailsInfo,
} from '@tallo/property';

import SpecificationsModal from './property-general-details-modal.vue';

const specificationsModal = ref<InstanceType<typeof SpecificationsModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.specifications));

function showModal() {
  specificationsModal.value?.modalRef?.show();
}
</script>
